





























































import ProjectForm from "@/views/projects/ProjectForm.vue";
import ProjectList from "@/views/projects/ProjectList.vue";
import ReportPage from "@/views/reports/ReportPage.vue";
// import EnroleesList from "@/views/enrolees/EnroleesList.vue";
import { useMainStore } from "@/store/storage";

import {
  computed,
  defineComponent,
  reactive,
  toRefs
} from "@vue/composition-api";

export default defineComponent({
  name: "ProjectPage",
  components: {
    ProjectList,
    ProjectForm,
    ReportPage
    // EnroleesList
  },
  setup() {
    const main = useMainStore();
    const state = reactive({
      activeId: -1,
      showEnrolees: true
    });

    function showProjectForm(status: boolean) {
      state.showEnrolees = status;
      main.state.projectId = "";
      main.resetProjectData;
    }

    const activeClient = computed(() => {
      const client = main.state.clients.find(
        (item) => item.id === main.state.projectData.clientId
      );
      if (client && client.companyName) return client.companyName;
      return "";
    });

    // root.$on('clicked',( e: Project )=>{
    // })

    // // function triggerAction(e: Project) {
    //     alert('d')
    // }

    return {
      ...toRefs(state),
      mainStore: main,
      mainState: main.state,
      showProjectForm,
      activeClient
    };
  }
});
